<template>
  <span>
    <span>Situação: </span>
    <strong>
      <v-chip
        v-if="!isLoading"
        :color="payload.color"
        :text-color="payload.textColor"
        class="text-uppercase"
        label
      >
        {{ payload.label }}
      </v-chip>
      <v-progress-circular
        v-else
        color="primary"
      />
    </strong>
  </span>
</template>

<script>
import DataTableChipColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import userPinStatus from 'Arch/enums/userPinStatus';

export default {
  name: 'UserPinChipStatus',
  extends: DataTableChipColumnVue,
  props: {
    value: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    status: userPinStatus,
  }),
  computed: {
    isLoading() {
      return this.loading;
    },
  },
};
</script>
